import axios from 'axios';
import { authHeader } from './services/auth-header';
import { REFRESH_TOKEN_URL, AUTHENTICATION_URL } from './config/api.urls';

const BASE_URL = `${process.env.VUE_APP_HTTP}${process.env.VUE_APP_API_ADDRESS}`;

const SESSION_EXPIRES_IN_DAYS = 8;
const SESSION_EXPIRES_IN_MILLISECONDS = SESSION_EXPIRES_IN_DAYS * 24 * 60 * 60 * 1000;


let sessionTimer = null;
let isFetchingRefreshToken = false;
let subscribers = [];
let isSecondAttempt = false;

function addSubscriber(callback) {
  subscribers.push(callback);
}

function onTokenRefreshed(success) {
  subscribers = subscribers.filter(callback => callback(success));
}

function stopTimer() {
  if (sessionTimer) {
    clearTimeout(sessionTimer);
  }
}

function resetSessionTimer() {
  stopTimer();
  sessionTimer = setTimeout(logout, SESSION_EXPIRES_IN_MILLISECONDS);
}

function logout() {
  onTokenRefreshed(false);
  const domain = new URL(window.location.href);
  window.$cookies.remove(
    'Authorization',
    null,
    process.env.VUE_APP_AUTHORIZATION_COOKIE_PATH,
  );
  isFetchingRefreshToken = false;
  stopTimer();
  window.location.href = domain.host;
}

function refreshToken() {
  axiosInstance
    .get(REFRESH_TOKEN_URL, {
      headers: { isRefreshToken: true },
    }).then(response => {
      if (response) {

        const { data } = response;

        window.$cookies.set(
          'Authorization',
          data.token,
          null,
          null,
          process.env.VUE_APP_AUTHORIZATION_COOKIE_PATH,
        );

        onTokenRefreshed(true);
        isFetchingRefreshToken = false;
      } else {
        logout();
      }
    }).catch(error => {
      console.log('Refresh token error', error);
      logout();
    });
}

export const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
  headers: authHeader(),
});

axiosInstance.interceptors.request.use(function (config) {
  const token = window.$cookies.get('Authorization');
  if (token) {
    resetSessionTimer();
  }
  return config;
});

axiosInstance.interceptors.response.use(
  response => {
    if (isSecondAttempt) {
      isSecondAttempt = false;
    }
    return response;
  },
  error => {
    const config = error.config;
    const status = error.response?.status;

    const token = window.$cookies.get('Authorization');
    if (status === 401 && token) {

      return new Promise((resolve, reject) => {
        if (!isFetchingRefreshToken) {
          isFetchingRefreshToken = true;
          refreshToken();
        }

        addSubscriber((success) => {
          if (success) {
            resolve(axiosInstance(config));
          } else {
            reject(axiosInstance(config));
          }
        });
      });

    } else if (!status && error.config.url === AUTHENTICATION_URL && error.message === 'Network Error') {
      return new Promise((resolve, reject) => {
        if (!isSecondAttempt) {
          isSecondAttempt = true;
          resolve(axiosInstance(config));
        } else {
          reject(error);
        }
      });
    } else {
      return Promise.reject(error);
    }
  },
);
